<script>
import createWorkflowItem from "../automation-archive/create-workflow-item";
import PremiumGateWorkflows from "./PremiumGateWorkflows.vue";

export default {
  name: "workflowlist",
  components: {
    createWorkflowItem,
    PremiumGateWorkflows
  },
  props: {
    isPaidAccount: {
      type: Boolean,
      default: false
    }
  },
  async mounted() {
    await this.$A.GetCurAccountData();

    let self = this;
    await this.getAllWorkflows();

    this.$root.$on("workflow_list::delete::workflow::confirmed", async function () {
      await self.$A.WorkflowService.Delete(self.deleteThis);
      self.deleteThis = null;
      await self.getAllWorkflows();
    });
    this.$root.$on("workflow_list::duplicate::workflow::confirmed", async function () {
      await self.$A.WorkflowService.Duplicate(self.duplicateThis);
      self.duplicateThis = null;
      await self.getAllWorkflows();
    });
    this.$root.$on("workflow_item:saved:successfully", async function () {
      self.editThis = 0;
      await self.getAllWorkflows();
    })
    this.$root.$on("workflow_item:canceled", function () {
      self.editThis = 0;
    });
  },
  data() {
    return {
      workflows: [],
      deleteThis: null,
      duplicateThis: null,
      editThis: null,
      fields: [
        {
          key: 'workflowinfo',
          sortable: false,
          label: ""
        },
        {
          key: 'edit',
          sortable: false,
          label: "",
          tdClass: "action-cell"
        },
        {
          key: 'menu',
          sortable: false,
          label: "",
          tdClass: "action-cell action-cell-menu"
        },
      ],
      mode: "workflow",
    };
  },
  computed: {
    sortedWorkflows: function () {
      function compare(a, b) {
        if (a.name < b.name)
          return -1;
        if (a.name > b.name)
          return 1;
        return 0;
      }

      return this.workflows.sort(compare);
    },
  },
  methods: {
    getAllWorkflows: async function () {
      var workflows = await this.$A.WorkflowService.GetAll();
      if (Array.isArray(workflows)) this.workflows = workflows;
    },
    editWorkflow: function (workflowId) {
      this.editThis = workflowId;
      this.$root.$emit("edit::workflow::from::automation");
    },
    onRowClicked(item) {
      this.editWorkflow(item.id);
      this.$root.$emit('bv::toggle::collapse', 'create-workflow-sidebar-right');
    },
    updateMode: function () {
      this.$root.$emit("create::workflow::from::automation");
    }
  },
};
</script>

<template>
  <div style="background-color: #eef2f5!important"
       class="on-mobile text-dark d-flex justify-content-center flex-md-wrap pb-5 px-3 px-md-0">
    <PremiumGateWorkflows v-if="!isPaidAccount" :isAutomationArchive="true" />
    <b-card v-else class="mt-3 p-0 h-75 account-workflow-card">
      <b-card-body>
        <div class="card-toolbar">
          <div class="toolbar-count">
            {{ sortedWorkflows.length }} {{ sortedWorkflows.length === 1 ? 'workflow' : 'workflows' }}
          </div>
          <div>
            <a
                class="button button-light button-green workflows-btn mb-0"
                v-b-toggle.create-workflow-sidebar-right
                @click="updateMode()"
            >Create Workflow</a>
          </div>
        </div>
        <!-- Workflows Table -->
        <b-table
            class="workflow-table mb-0"
            :items="sortedWorkflows"
            :fields="fields"
            responsive
            hover
            thead-class="d-none"
            tbody-tr-class="workflow-row"
            @row-clicked="onRowClicked"
        >
          <template #cell(workflowinfo)="data">
            <span class="column-header-text">{{ data.item.name }}</span>
          </template>
          <template #cell(edit)="data">
            <button
                class="row-edit-btn"
                v-b-toggle.create-workflow-sidebar-right
                @click.stop="editWorkflow(data.item.id)"
            >
              Edit
            </button>
          </template>
          <template #cell(menu)="data">
            <span @click.stop>
            <b-dropdown
                variant="link"
                toggle-class="row-menu-toggle"
                menu-class="row-menu"
                no-caret
                right
                no-flip
                boundary="viewport"
                offset="4"
            >
              <template #button-content>
                <b-icon-three-dots-vertical />
                <span class="sr-only">More actions</span>
              </template>
              <b-dropdown-item
                  v-b-modal.workflow_list_duplicateWorkflowModal
                  @click="duplicateThis = data.item.id"
              >
                Duplicate
              </b-dropdown-item>
              <b-dropdown-item
                  :data-cy="`delete-${data.item.name}`"
                  v-b-modal.workflow_list_deleteWorkflowModal
                  @click="deleteThis = data.item.id"
              >
                Delete
              </b-dropdown-item>
            </b-dropdown>
            </span>
          </template>
        </b-table>
        <!-- Modals -->
        <modal
            name="workflow_list_deleteWorkflowModal"
            eventToEmitOnConfirmation="workflow_list::delete::workflow::confirmed"
            question="Delete This Workflow?"
            body="Are you sure you want to delete this workflow? You cannot undo this action."
            confirm-button-text="Yes, Delete"
        />
        <modal
            name="workflow_list_duplicateWorkflowModal"
            eventToEmitOnConfirmation="workflow_list::duplicate::workflow::confirmed"
            question="Duplicate This Workflow?"
            confirm-button-text="Yes, Duplicate"
            body="Create a copy of this workflow."
        />
        <createWorkflowItem :workflow-id="editThis" :hide-current-stage-active="true"/>
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped>
.account-workflow-card {
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

::v-deep .account-workflow-card .card-body {
  padding: 0px;
}

.card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid #E5E7EB;
}

.toolbar-count {
  font-family: 'Open Sans';
  font-size: 13px;
  color: #6B7280;
}

::v-deep .workflow-table table {
  margin-bottom: 0;
}

::v-deep .workflow-table table td {
  padding: 14px 24px !important;
  vertical-align: middle !important;
  border-top: 1px solid #F1F2F4;
  border-bottom: 0;
}

::v-deep .workflow-table tbody tr:first-child td {
  border-top: 0;
}

::v-deep .workflow-table table td.action-cell {
  width: 1%;
  white-space: nowrap;
  text-align: right;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

::v-deep .workflow-table table td.action-cell-menu {
  padding-left: 0 !important;
  padding-right: 16px !important;
}

::v-deep .workflow-row {
  cursor: pointer;
}

::v-deep .workflow-table.table-hover tbody tr:hover,
::v-deep .workflow-table tbody tr:hover {
  background-color: #F9FAFB;
  color: inherit;
}

::v-deep .row-menu-toggle {
  color: #6B7280;
  padding: 4px 6px;
  border-radius: 4px;
}

::v-deep .row-menu-toggle:hover,
::v-deep .row-menu-toggle:focus {
  color: #1B1B1C;
  background-color: #F1F2F4;
  text-decoration: none;
  box-shadow: none;
}

::v-deep .row-menu {
  min-width: 8rem;
  font-size: 14px;
}

.column-header-text {
  font-family: 'Open Sans';
  font-size: 14px;
  line-height: 20px;
  color: #1B1B1C;
}

.row-edit-btn {
  background: transparent;
  border: 1px solid #D1D5DB;
  color: #1B1B1C;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 6px;
  line-height: 20px;
}

.row-edit-btn:hover {
  background: #FFFFFF;
  border-color: #B4B9C0;
}

.row-edit-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);
}

.workflows-btn {
  padding: 9px 17px !important;
  font-weight: normal;
  height: 38px;
  background: #019256;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
}

@media (max-width: 576px) {
  .card-toolbar {
    padding: 12px 16px;
  }

  .workflows-btn {
    padding: 8px !important;
    border-radius: 5px;
    font-weight: normal !important;
  }
}
</style>
